var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartLightLeftComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1233,
    height: 1611,
    viewBox: "0 0 1233 1611",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter0_f_2137_17439)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M864.5 1286C902.667 1245.33 948.5 1152.5 826.5 1106.5C674 1049 427.5 1115 397 1081C366.5 1047 311 1006 354 901.5C397 797 575 683.5 578.5 588.5C582 493.5 654 499 548 400C442 301 36 67 1.5 56.5",
    stroke: "#2F00FF",
    strokeWidth: 11
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2137_17439",
    x: -321.202,
    y: -269.862,
    width: 1553.4,
    height: 1880.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 160.55,
    result: "effect1_foregroundBlur_2137_17439"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartLightLeftComponents);
export default __webpack_public_path__ + "static/media/StartLightLeftComponents.1c071871cab02957527aa5401ee57119.svg";
export { ForwardRef as ReactComponent };